export default "##### Welcome to Carma<br />{name}\n\nWe’ve successfully created your account.\n\nRedirecting you back to your car in {second}.\n";